// 房态首页的接口
import fetch from '../tjFetch.js'
import { SetupApi } from './types'
import abLS from '@/business/abLocalStorage'

const apiConfig = {
  permissions: '/api/pms/per/list.api',
  addConfiguration: '/api/pms/labelConfigurations/add.api',
  getConfigByType: '/api/pms/labelConfigurations/list.api',
  getAllConfigList: '/api/pms/labelConfigurations.api',
  deleteConfiguration: '/api/pms/labelConfigurations/delete.api',
  editConfiguration: '/api/pms/labelConfigurations/edit.api',
  financeDetailList: '/api/pms/incomeExpenditureRecords/list.api',
  editFinanceDetail: '/api/pms/incomeExpenditureRecords/edit.api',
  deleteFinanceDetail: '/api/pms/incomeExpenditureRecords/delete.api',
  staffList: '/api/pms/manager/list.api',
  editStaff: '/api/pms/manager/save.api',
  deleteStaff: '/api/pms/manager/delete.api'
}

const getData = (fromData = {}, key: string = 'data') => {
  return {
    data: {},
    [key]: fromData,
    headers: {
      'accessToken': abLS.getAccessToken() || ''
    },
    withCredentials: true
  }
}

const api: SetupApi = {
  /** 获取当前用户在当前门店的权限 */
  getPermissions(params) {
    return fetch.get(apiConfig.permissions, getData(params, 'params'))
  },
  /** 新增财务项目 */
  addConfiguration(fromData) {
    return fetch.post(apiConfig.addConfiguration, getData(fromData))
  },
  /** 财务项目列表(某类型) */
  getConfigByType(fromData) {
    return fetch.get(apiConfig.getConfigByType, getData(fromData))
  },
  /** 财务项目列表(全部) */
  getAllConfigList() {
    return fetch.get(apiConfig.getAllConfigList, getData())
  },
  /** 删除财务项目 */
  deleteConfiguration(fromData) {
    return fetch.post(apiConfig.deleteConfiguration, getData(fromData))
  },
  /** 编辑财务项目 */
  editConfiguration(fromData) {
    return fetch.post(apiConfig.editConfiguration, getData(fromData))
  },
  /** 财务明细列表 */
  financeDetailList(fromData) {
    return fetch.post(apiConfig.financeDetailList, getData(fromData))
  },
  /** 编辑财务明细 */
  editFinanceDetail(fromData) {
    return fetch.post(apiConfig.editFinanceDetail, getData(fromData))
  },
  /** 删除财务明细 */
  deleteFinanceDetail(fromData) {
    return fetch.post(apiConfig.deleteFinanceDetail, getData(fromData))
  },
  /** 员工列表 */
  getStaffList(params) {
    return fetch.get(apiConfig.staffList, getData(params, 'params'))
  },
  /** 添加/修改员工 */
  editStaff(fromData) {
    return fetch.post(apiConfig.editStaff, getData(fromData))
  },
  /** 删除员工 */
  deleteStaff(params) {
    return fetch.post(apiConfig.deleteStaff, getData(params))
  }
}

export default api
